<template>
  <div>
    <div class="b-header">
      <div class="b-home-container">
        <div class="b-main">
          <div class="b-left">
            <a href="/">
            <img src="../../../assets/img/logo3.png" />
            </a>
          </div>
          <div class="b-right">
            <div class="b-right-button">
<!--              <ul>-->
<!--                <li class="b-link" v-for="item in LinkList"-->
<!--                  :key="item">-->
<!--                  <a class="b-link-a" :href="item.linkUrl">-->
<!--                    {{ item.name }}-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
              <div class="mask" v-if="showModal" @click="showModal=false"></div>
              <div class="pop" v-if="showModal">
                <br>
                <br>
                <br>
                <p>
                  <font size="5"> &nbsp;&#8611;&nbsp;</font>
                <a href="https://user.transmed.sjtu.edu.cn/ums/user/index.html#/login" target="_blank" style="font-size: 16px">校外用户入口 (Google 浏览器)</a>
                </p>
                <br>
                <p>
                  <font size="5"> &nbsp;&#8611;&nbsp;</font>
                <a href="https://user.transmed.sjtu.edu.cn" target="_blank" style="font-size: 16px">校内用户入口 (Google 浏览器)</a>
                </p>
                <br>
<!--                <p>-->
<!--                  <font size="5"> &nbsp;&#8611;&nbsp;</font>-->
<!--                <a href="https://202.120.40.253/vms/Pages/ApplyBookingVisitor.aspx" target="_blank" style="font-size: 16px">访客自主预约</a>-->
<!--                </p>-->
<!--                <br>-->
<!--                <br>-->
                <button @click="showModal=false" class="btn">关闭窗口</button>
              </div>
              <ul>
<!--                <li class="b-link">-->
<!--                  <a class="b-link-a" href="https://202.120.40.253/vms/Pages/ApplyBookingVisitor.aspx" target="_blank" >-->
<!--                    Visitors-->
<!--                  </a>-->
<!--                </li>-->
                <li class="b-link">
                  <a class="b-link-a" @click="showModal=true">
                    User Login
                  </a>
                </li>
                <li class="b-link">
                                  <a class="b-link-a" href="/">
                                    CN
                                  </a>
                                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
const IP_URL = 'https://transmed-data.sjtu.edu.cn';  // 交大服务器地址
//const IP_URL = 'http://localhost:8088';  // 本地地址
//const IP_URL = 'http://47.105.70.79:8088';  // 测试服务器地址

export default {
  IP_URL,
  data () {
    return {
      LinkList: [],
      showModal: false
    };
  },
  mounted () {
    this.LinkList = [
      {
        linkUrl:'#',
        name: "访客预约"
      },
      {
        linkUrl:'#',
        name: "用户登陆"
      },
      {
        linkUrl:'#',
        name: "EN"
      }
    ];
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/base.css";

.mask {
  background-color: #000;
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1
}
.pop {
  background-color: #fff;
  border-radius: 10px;
  position: fixed;
  top: 200px;
  left: 500px;
  width: calc(100% - 1000px);
  height:230px;
  z-index: 2
}
.btn {
  background-color: #66b1ff;
  border-radius: 4px;
  border: 1px solid #c8c9cc;
  padding: 4px 12px;
}

.b-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0px;
  .b-left {
    width: 950px;
    /* 公司logo */
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .b-right {
    .b-right-button {
      display: flex;
      align-items: center;
      li{
        display: inline-block;
        padding-right: 14px;
        margin-right: 14px;
        border-right: 1px solid #fff;
        .b-link-a{
          font-size: 16px;
          color: #fff;
          line-height: 14px;
        }
      }
      li:last-child{
        border-right: none;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/header/en/index.vue